<template>
<div>
    <!-- <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_manage_food">
                <img src="@/assets/cooking.png">
            </div>
            <h2 class="title_manage_food">จัดการรายการอาหาร</h2>
        </div>
        <v-btn class="size_title_manage_food white--text" color="#28ab28" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div> -->
    <MenuManageFood />
    <v-card>
        <div class="pa-3">
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between card_menu_header_manage_food">
                        <div class="mr-1">
                            <v-btn :class=" title === 'food' ? 'size_title_manage_food white--text' : 'size_title_manage_food'" :color="title === 'food' ? '#038cc1' : ''" @click="page('food')" height="50px" width="100%">เมนูอาหาร</v-btn>
                        </div>
                        <div class="ml-1">
                            <v-btn :class=" title === 'topping' ? 'size_title_manage_food white--text' : 'size_title_manage_food'"  :color="title === 'topping' ? '#038cc1' : ''" @click="page('topping')" height="50px" width="100%">ท็อปปิ้ง</v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <ManageFoodType :title="title" />
                </v-col>
            </v-row>
        </div>
    </v-card>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import MenuManageFood from '@/components/menuadmin/MenuManageFood.vue'
import ManageFoodType from '@/components/menuadmin/ManageFoodType.vue'
export default {
    name: 'manageFood',
    components: {
        MenuManageFood,
        ManageFoodType
    },
    data() {
        return {
            title: 'food',
        }
    },
    methods: {
        async page(type) {
            this.title = type
        }
    },
    created(){
        HTTP.get('/check_cretae_rang', {
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            }
        }).catch((error) => {
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
        })
    }
}
</script>
